import React, { useMemo, useCallback } from "react";
import styled from "styled-components";
import { PaginatedEntityTable } from "components/common";
import { DEFAULT_LAYOUT } from "views/logic/fieldactions/ChangeFieldType/Constants";
import { queryKey, fetchFieldTypeUsages } from "views/logic/fieldactions/ChangeFieldType/hooks/useFieldTypeUsages";
import useColumnRenderers from "views/logic/fieldactions/ChangeFieldType/hooks/useColumnRenderers";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import useCurrentStream from "views/logic/fieldactions/ChangeFieldType/hooks/useCurrentStream";
import isIndexFieldTypeChangeAllowed from "components/indices/helpers/isIndexFieldTypeChangeAllowed";
import useIndexSetsList from "components/indices/hooks/useIndexSetsList";
const Container = styled.div`
  margin-top: 20px;
`;
const mapper = (indexSets) => {
  if (!indexSets) return null;
  return Object.fromEntries(indexSets.map((indexSet) => [indexSet.id, indexSet]));
};
const IndexSetsTable = ({ field, setIndexSetSelection, fieldTypes, initialSelection }) => {
  const { data } = useIndexSetsList();
  const currentStreams = useCurrentStream();
  const mappedIndexSets = useMemo(() => mapper(data == null ? void 0 : data.indexSets), [data == null ? void 0 : data.indexSets]);
  const fetchEntities = (searchParams) => fetchFieldTypeUsages({ field, streams: currentStreams }, searchParams);
  const columnRenderers = useColumnRenderers(fieldTypes);
  const onChangeSelection = useCallback(
    (newSelection) => {
      setIndexSetSelection(newSelection);
    },
    [setIndexSetSelection]
  );
  const isEntitySelectable = useCallback(
    (entity) => {
      const indexSetId = entity.id;
      return isIndexFieldTypeChangeAllowed(mappedIndexSets[indexSetId]);
    },
    [mappedIndexSets]
  );
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "Index Sets",
      tableLayout: DEFAULT_LAYOUT,
      withoutURLParams: true,
      fetchEntities,
      keyFn: (searchParams) => queryKey(searchParams, field, currentStreams),
      columnRenderers,
      entityAttributesAreCamelCase: true,
      bulkSelection: {
        onChangeSelection,
        initialSelection,
        actions: /* @__PURE__ */ React.createElement(BulkActionsDropdown, null),
        isEntitySelectable
      },
      searchPlaceholder: "Search for index sets",
      fetchOptions: { refetchInterval: 5e3 }
    }
  ));
};
export default IndexSetsTable;
